export enum FilterOptionTypes {
    CHIPS = 'chips',
    CHECKBOX = 'checkbox',
    LIST = 'list'
}

export enum FilterSetTypes {
    TOGGLES = 'toggles',
    ACCORDIONS = 'accordions',
    LABELS = 'labels'
}

export enum SelectedFilterValues {
    BUTTONS = 'buttons',
    LABELS = 'labels'
}
